import Vue from "vue";
import '@babel/polyfill'
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import router from "./router";
// import VueRouter from 'vue-router'
import store from "./store";
//import Loading from "@/components/lib/loading";
import CenterContainer from "@/components/lib/center-container";
// import VueReCaptcha from "vue-recaptcha-v3";

import "./vendors/normalize/normalize.css";
import "./vendors/bootstrap/css/bootstrap.css";
import "./vendors/feather_icon/css/feather_icon.css";
import "./resources/css/main.css";
import "./resources/css/font-awesome.min.css";
import "./resources/css/bulma.css";
import './resources/css/vue-select.css';
// import "./vendors/fontawesome/h5p-font-awesome.min.css";

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
//import DatePicker from 'vue2-datepicker';
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import VueNumeric from 'vue-numeric';
import VeeValidate, { Validator } from 'vee-validate';
import th from 'vee-validate/dist/locale/th';
import Moment from 'moment';
//import { Pagination } from 'bootstrap-vue/esm/components';
import Pagination from 'bootstrap-vue';
import swal from 'vue-sweetalert2';//https://sweetalert2.github.io/
// import Vue2Filters from 'vue2-filters';//https://github.com/freearhey/vue2-filters
import VueSelect from 'vue-select';


Vue.use(swal)
// Vue.use(Vue2Filters)
Vue.use(Pagination)
Vue.use(Loading, {
  // props
  canCancel: false,
  color: '#0ea7e3',
  loader: 'dots',
  width: 164,
  height: 64,
  backgroundColor: '#ffffff',
  opacity: 0.5,
  zIndex: 999,

}, {
    // slots
  })


Vue.use(VueNumeric);
Vue.use(BootstrapVue);

Validator.localize({ 'th': th });
Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields',
  locale: 'th',
  events: 'change|blur'
});


Vue.use(Moment);
Vue.use(VueSelect);

// Vue.use(VueRouter)
Vue.component("loading", Loading);
Vue.component("center-container", CenterContainer);
Vue.component("DatePicker", DatePicker);

Vue.component('v-select', VueSelect)

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
}).$mount("#app");
